import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import { BrowserRouter, Switch, Router, Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import AppStoreBadge from './Assets/svgs/appStoreBadge.svg';
import GoogleplayBadge from './Assets/svgs/googlePlayBadge.svg';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { auth } from 'firebase';
class SubmitHook extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tweetUrl: null,
      loading: false,
      error: null,
      response: null,
      data: null,
    };

    this.setState.bind(this);
  }

  submitUrl = (e) => {
    e.preventDefault();
    this.setState({ loading: true, data: null });
    const { tweetUrl } = this.state;

    const body = {
      tweetUrl: tweetUrl,
    };
    axios
      .post('https://us-central1-threads-1511.cloudfunctions.net/app/submit', body, {
        headers: {
          // 'Access-Control-Allow-Origin': 'http://localhost:5001',
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        this.setState({ data: res.data, loading: false });
      })
      .catch((e) => {
        this.setState({ error: e, loading: false });
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    return (
      <div className="App">
        <div className="AppHeader">
          <Link style={{ textDecoration: 'none' }} to="/">
            <div className="header">
              <p className="title">threads</p>
              <p className="tagLine">bringing you the best of twitter</p>
            </div>
          </Link>
          <div className="badges">
            <a href="https://apps.apple.com/in/app/threads/id1512677811">
              <div className="ctaBadge">
                <img src={AppStoreBadge} alt="App Store Download" />
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.threadsapp">
              <div className="ctaBadge">
                <img src={GoogleplayBadge} alt="Google Play Download" />
              </div>
            </a>
          </div>
        </div>
        <div className="section_fullPage">
          <div style={{ paddingTop: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ReactPlayer url="https://youtu.be/-Wto4p13KZg" />
          </div>
        </div>
        {/* <div style={{marginBlockStart: 100}}> */}
        {/* <div className="mainContent"> */}
        {/* <div className="newsletterContainer" style={{width: '100%'}}> */}
        {/* <form className="fullForm" onSubmit={this.submitUrl}> */}
        {/* <p className="submit">Submit Threads below</p> */}
        {/* <p className="newsletterTitle">Submit threads🧵</p> */}
        {/* <p className="submitInfo">Please put the twitter url of the tweet that begins the thread</p> */}
        {/* <input className="inputUrl" type='text' name="tweetUrl" placeholder="Twitter URl" style={{width: '90%'}} onChange={this.handleChange}/> */}
        {/* <button className="SubmitButton">Submit</button> */}
        {/* </form> */}
        {/* <div>{this.state.loading === false ? this.state.data : 'Submitting...'}</div> */}
        {/* </div> */}
        {/* </div> */}
        <div style={{ marginBlockStart: 200, marginBlockEnd: 200 }}>
          <div className="newsletterContainer">
            <p className="newsletterTitle">✉️ Newsletter</p>
            <p style={{ paddingInlineStart: 20, paddingInlineEnd: 20 }}>Weekly digests of threads</p>
            <input className="inputUrl sm" type="email" name="email" placeholder="your email :)" />
            <button className="SubmitButton">Subscribe</button>
          </div>
        </div>
        <div className="linkContainer">
          <Link className="linkButton" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className="linkButton" to="/terms-and-conditions">
            Terms and Conditions
          </Link>
          <Link className="linkButton" to="/eula">
            User License Agreement
          </Link>
        </div>
      </div>
    );
  }
}

function Submit() {
  const [email, setEmail] = useState(null);
  const [subscribing, setSubscribing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState(null);
  const [buttonText, setButtonText] = useState('Try it');
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <div className="App">
      <div className="AppHeader">
        <Link style={{ textDecoration: 'none' }} to="/">
          <div className="header">
            <p className="title">threads</p>
            <p className="tagLine">bringing you the best of twitter</p>
          </div>
        </Link>
        <div className="badges">
          <a href="https://apps.apple.com/in/app/threads/id1512677811">
            <div className="ctaBadge">
              <img src={AppStoreBadge} alt="App Store Download" />
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.threadsapp">
            <div className="ctaBadge">
              <img src={GoogleplayBadge} alt="Google Play Download" />
            </div>
          </a>
        </div>
      </div>
      <div className="section_fullPage">
        <div style={{ paddingTop: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ReactPlayer url="https://youtu.be/-Wto4p13KZg" />
        </div>
      </div>
      <div style={{ marginBlockStart: 200, marginBlockEnd: 200 }}>
        <MailchimpSubscribe
          url={'https://app.us10.list-manage.com/subscribe/post?u=0401a1f5a4b1055a52164464a&amp;id=9ee8cd1a59'}
          render={({ subscribe, status, message }) => {

            if(status === 'sending') {
              setButtonText('Subscribing...');
              setSubscribing(true);
            } 
            if(status === 'error') {
              setButtonText('Try it');
              setError(message.split(/<a/)[0]);
              setSubscribing(false);
            }
            if(status === 'success') {
              setButtonText('Great call!');
              setSubscribed(true);
              setSubscribing(false);
            }
            return(
              <form onSubmit={e => {
                e.preventDefault();
                if(!subscribing && email && !subscribed)
                subscribe({
                  EMAIL: email,
                })
              }}>
                <div className="newsletterContainer">
                  <p className="newsletterTitle">✉️ Smarter in just five minutes</p>
                  <p style={{paddingInlineStart:  20, paddingInlineEnd:  20}}>Enjoyable and insighful threads directly in your inbox every weekend</p>
                  <input className="inputUrl sm" type='email' name="email" placeholder="your email :)" onChange={handleChange} />
                  <button className="SubmitButton" >{buttonText}</button>
            {error ? <p>Looks like something went wrong {error}</p> : null}
              </div>
              </form>
            )
          }}
        />
      </div>
      <div className="linkContainer">
        <Link className="linkButton" to="/privacy-policy">
          Privacy Policy
        </Link>
        <Link className="linkButton" to="/terms-and-conditions">
          Terms and Conditions
        </Link>
        <Link className="linkButton" to="/eula">
          User License Agreement
        </Link>
      </div>
    </div>
  );
}

export default Submit;
